<script>
  import {flash} from '../stores/flash'
</script>

<div class="flashes">
  <div class="flashes-wrapper">
    {#each $flash as fl}
      <div class="flash {fl.type} {fl.removing ? 'removing' : ''}">
        <span class="dinb vmid">{fl.message}</span>
        <span class="icon-p-close" onclick={() => flash.close(fl)}/>
      </div>
    {/each}
  </div>
</div>

<style globa>
  .dinb {
    display: inline-block;
  }

  .vmid {
    vertical-align: middle;
  }

  .icon-p-close {
    font-size: 10px;
    cursor: pointer;
  }

  .flashes {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    pointer-events: none;
    padding: 20px;
    z-index: 999;
  }

  .flashes-wrapper {
    display: flex;
    flex-direction: column;
    align-items: end;
    gap: 16px;
  }

  .flash.error {
    background: #9f3a38;
  }

  .flash.removing {
    animation: flyout 0.3s ease-out;
  }

  .flash {
    position: relative;
    pointer-events: auto;
    background: #1B1C1D;
    color: white;
    overflow: hidden;
    max-width: 300px;
    display: flex;
    gap: 20px;
    padding: 10px;
    align-items: center;
    animation: flyin 0.3s ease-out;
  }

  @keyframes flyin {
    0% {
      opacity: 0;
      transform: translateY(-100px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes flyout {
    0% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateY(-100px);
    }
  }
</style>